<script>
	export let family;
	export let list = [];
	export let selected = [];
	export let display = item => item;
	export let filter = item => true;
	let show = false;
	let search = "";
	function funk(e) {
		if(show && !top.contains(e.target) && !bottom.contains(e.target)) {
			show = false;
		}
	}
	let top;
	let bottom;
	import Sortable from '../components/Sortable.svelte';
</script>
<style>
	.selected {
		background-color: yellow;
		border-radius: 5px;
		margin: 5px;
	}
	.wow:hover {
		background-color: blue;
	}
	.ib {
		display: inline-block;
	}
</style>
<svelte:window on:click="{funk}" />

<span bind:this={top} class="ib">
	<Sortable
		{family}
		bind:list={selected}
		let:item
		let:index
		style="display: inline"
	>
		<span on:click|stopPropagation={() => {selected.splice(index, 1); selected = selected}} class="selected">{display(list[item])}</span>
	</Sortable>
	<label>
		🔍
		<input type="search" on:click={() => show = true} bind:value={search} />
	</label>
	<button on:click={() => {selected = []; search = "";}}>
		clear selection
	</button>
</span>
<br>
{#if show}
	<select bind:this={bottom} class="ib" multiple bind:value={selected} on:change={() => {/*show = false; search = ""*/}}>
		{#each list as item, index}
			{#if filter(item)}
				<option class="wow" style={(display(item) + '').toLowerCase().includes(search.toLowerCase()) && !selected.includes(index) ? '' : 'display: none;'} value={index}>
					{display(item)}
				</option>
			{/if}
		{/each}
	</select>
{/if}
